import React from "react";
import CopyrightPreviewFormOne from "../../../../../components/preview_applications/copyright/CopyrightPreviewFormOne";
import CopyrightPreviewFormTwo from "../../../../../components/preview_applications/copyright/CopyrightPreviewFormTwo";
import CommonDetails from "../../details/CommonDetails";
import { CopyrightGenerateAttachArray } from "../../../../../utils/CopyrightGenerateAttachArray";
import Loader from "../../../../../components/custom/Loader";
import { useParams } from "react-router-dom";
import { useShowHearingCopyrightDetailsQuery } from "../../../../../redux/api/submittedCopyrightAgreementApiSlice";
import { useAuth } from "../../../../../utils/authorization";
import { transformCopyrightData } from "../../../../../utils/transformCopyrightData";
import HearingContent from "../../../../../components/common-content/HearingContent";
import PaymentPreview from "../../../../../components/preview_applications/payment/PaymentPreview";

const HearingCopyrightDetails = () => {
  const { authUser } = useAuth();
  const { id } = useParams();
  const { data, isLoading } = useShowHearingCopyrightDetailsQuery(id, {
    refetchOnMountOrArgChange: true,
  });

  const details = data?.data?.profileDetail;

  const forInfo = transformCopyrightData(data);

  if (isLoading) {
    return <Loader />;
  }
  const infoTable = CopyrightGenerateAttachArray(forInfo);

  const info = {
    fileStatus: Number(data?.data?.fileStatus),
    noteNumber: data?.data?.trackReg,
    regNumber: "",
    applicantName: details?.profileDetailType?.[0]?.name,
    workTitle: details?.workTitle,
    category: details?.category?.name,
    amount: data?.data?.amount,
    challan: Number(data?.data?.st) === 3 ? "চালান" : "ট্রেজারি",
    challanNumber:
      Number(data?.data?.st) === 3
        ? data?.data?.echallanId
        : data?.data?.treasuryNo,
    treasuryDate: data?.data?.treasuryDate || new Date(),
    admin: data?.data?.admin,
    hearing: data?.data?.hearing,
    // TODO: certificate data
    name: details?.profileDetailType?.[0].name,
    email: details?.profileDetailType?.[0].mobile,
    address: details?.profileDetailType?.[0].address,
  };

  const formOne = (
    <div className="pt-5">
      <CopyrightPreviewFormOne data={data?.data} />
    </div>
  );
  const formTwo = (
    <div className="pt-5">
      <CopyrightPreviewFormTwo data={details} />
    </div>
  );

  const comments =
    authUser?.id === 8
      ? data?.data?.comments.find((c) => Number(c.submit) === 2)
      : data?.data?.comments.length > 0 && data?.data?.comments[0];

  const commentsValue = data?.data?.comments.find(
    (c) => Number(c.submit) === 2
  );

  const noteSheetList =
    data?.data?.comments.filter((c) => Number(c.submit) === 1) ?? [];
  const pageTitle =
    info.fileStatus === 20
      ? "শুনানীর চিঠি (অনুমোদিত)"
      : info.fileStatus === 10
      ? "শুনানীর চিঠি"
      : "শুনানীর নথি";

  const content = <HearingContent comments={commentsValue} info={info} />;

  const commentsNoteSheet = {
    noteSheetList,
    noteSheetValues: comments?.status,
  };
  const apptype = Number(data?.data?.apptype) === 1 ? "কপিরাইট" : "চুক্তিপত্র";

  return (
    <div>
      <CommonDetails
        content={content}
        commentsNoteSheet={commentsNoteSheet}
        formOne={formOne}
        formTwo={formTwo}
        payment={
          <div className="p-4 mt-5">
            <PaymentPreview data={data?.data} />
          </div>
        }
        info={info}
        infoTable={infoTable}
        breadcrumbsTitle={apptype + " - " + pageTitle}
      />
    </div>
  );
};

export default HearingCopyrightDetails;
